module.exports = __webpack_public_path__ + "img/Outstanding_32.0859bc5a.png";